export class SortService {
    constructor(defaultSortProperty: string, defaultSortDirection: string) {
        this.sortProperty = defaultSortProperty;
        this.sortDirection = defaultSortDirection;
    }

    sortProperty: string;
    sortDirection: string;

    sort<T>(items: T[], propertyName: string, direction?: string): T[] {
        // Update lastSort
        if (this.sortProperty != propertyName) {
            this.sortProperty = propertyName;
            this.sortDirection = 'asc';
        } else {
            this.sortDirection = this.sortDirection == 'asc' ? 'desc' : 'asc';
        }

        if (direction) {
            // Override with provided direction
            this.sortDirection = direction;
        }

        var dirMultiplier = this.sortDirection == 'asc' ? 1 : -1;

        var compareStrings = function (a, b) {
            let aStr = a[propertyName];
            let bStr = b[propertyName];
            if (aStr > bStr)
                return 1 * dirMultiplier;
            if (aStr < bStr)
                return -1 * dirMultiplier;

            return 0;
        };

        var compareBooleans = function (a, b) {
            let aBool = a[propertyName];
            let bBool = b[propertyName];
            if (aBool && !bBool)
                return -1 * dirMultiplier;
            if (!aBool && bBool)
                return 1 * dirMultiplier;

            return 0;
        };

        var compareNumber = function (a, b) {
            let aNum = a[propertyName];
            let bNum = a[propertyName];
            return aNum - bNum;
        }

        var compareAny = function (a, b) {
            let aAny = a[propertyName];
            if (typeof aAny == 'string')
                return compareStrings(a, b);
            else if (typeof aAny == 'boolean')
                return compareBooleans(a, b);
            else if (typeof aAny == 'number')
                return compareNumber(a, b);
            else
                return 0;
        }

        return items.sort(compareAny);
    }
}